(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ClearcorpTradesOutstandingReportService', ClearcorpTradesOutstandingReportService);

    ClearcorpTradesOutstandingReportService.$inject = ['$resource'];

    function ClearcorpTradesOutstandingReportService($resource) {
        var resourceUrl =  'api/trades-outstanding/:id';
        
        return $resource(resourceUrl, {}, {
        	
            'getTradesOutstandingExcel':{
                method: 'POST',
                url: 'api/trades-outstanding-report/export-excel',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',fromSetDate :'@fromSetDate',toSetDate:'@toSetDate', currencyPairId : '@currencyPairId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            },
            'getTradesOutstandingCsv':{
                method: 'POST',
                url: 'api/trades-outstanding-report/export-csv',
                params: {bankId : '@bankId', branchId : '@branchId', customerId : '@customerId', instrumentId : '@instrumentId',fromSetDate :'@fromSetDate',toSetDate:'@toSetDate', currencyPairId : '@currencyPairId'},
                responseType: 'arraybuffer',
                 transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                },
                transformResponse: function(data, headers) {
                    return {
                        data: data,
                        headers: headers
                    };   
                } 
            }
        });
    }
   })();
